export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-1-c526feb04761819c5c05fe2165aaa3dd.jpg";